<template>
  <div class="child-bg-image">
    <div class="bg-image-section" />
    <div class="content-section">
      <organizations-page />
    </div>
  </div>
</template>

<script>
import OrganizationsPage from '../Components/OrganizationsPage.vue';
export default {
  name: 'Organizations',
  components: {
    'organizations-page': OrganizationsPage,
  },
};
</script>

<style scoped></style>
